export const evilWizardDead = new Image();
evilWizardDead.src = "assets/characterSprites/evilWizard/Death.png";
evilWizardDead.width = 1200/8;
evilWizardDead.height = 150/1;
evilWizardDead.yOffset = 40;
evilWizardDead.xOffset = 150;
evilWizardDead.cycleLoop = [0,1,2,3,4,5,6,7];